import { IDBService } from '../IDBService.js';
import { fileToArrayBuffer } from './utils.js';
export class FileStorage extends IDBService {
    constructor() {
        super(...arguments);
        this.addFile = async (file, { transaction } = {}) => {
            const buffer = file.file ? await fileToArrayBuffer(file.file) : undefined;
            return this.run('files', (store) => {
                return store.put({
                    id: file.id,
                    // IDB doesn't support boolean indexes
                    remote: file.remote ? 'true' : 'false',
                    deletedAt: null,
                    name: file.name,
                    type: file.type,
                    url: file.url,
                    buffer,
                });
            }, 'readwrite', transaction);
        };
        this.hydrateFileData = (raw) => {
            raw.remote = raw.remote === 'true';
            const buffer = raw.buffer;
            delete raw.buffer;
            raw.file = buffer
                ? arrayBufferToBlob(buffer, raw.type)
                : undefined;
            return raw;
        };
        this.markUploaded = async (id, { transaction } = {}) => {
            const current = await this.getFileRaw(id, { transaction });
            if (!current) {
                throw new Error('File is not in local database');
            }
            return this.run('files', (store) => {
                return store.put(Object.assign(Object.assign({}, current), { remote: 'true' }));
            }, 'readwrite', transaction);
        };
        this.getFileRaw = async (id, { transaction } = {}) => {
            const raw = await this.run('files', (store) => {
                return store.get(id);
            }, 'readonly', transaction);
            if (!raw) {
                return undefined;
            }
            return raw;
        };
        this.getFile = async (id, { transaction } = {}) => {
            const raw = await this.getFileRaw(id, { transaction });
            if (!raw) {
                return undefined;
            }
            return this.hydrateFileData(raw);
        };
        this.markPendingDelete = async (id, { transaction } = {}) => {
            const current = await this.getFileRaw(id, { transaction });
            if (!current) {
                throw new Error('File is not in local database');
            }
            return this.run('files', (store) => {
                return store.put(Object.assign(Object.assign({}, current), { deletedAt: Date.now() }));
            }, 'readwrite', transaction);
        };
        this.listUnsynced = async () => {
            const raw = await this.run('files', (store) => {
                return store.index('remote').getAll('false');
            }, 'readonly');
            return raw.map(this.hydrateFileData);
        };
        this.iterateOverPendingDelete = (iterator, transaction) => {
            return this.iterate('files', (store) => {
                return store
                    .index('deletedAt')
                    .openCursor(IDBKeyRange.lowerBound(0, true));
            }, (value, store) => {
                iterator(this.hydrateFileData(value), store);
            }, 'readwrite', transaction);
        };
    }
    deleteFile(id, { transaction } = {}) {
        return this.run('files', (store) => {
            return store.delete(id);
        }, 'readwrite', transaction);
    }
}
export function arrayBufferToBlob(buffer, type) {
    return new Blob([buffer], { type });
}
//# sourceMappingURL=FileStorage.js.map